<template>
  <div v-if="openModal">
    <div class="modal" id="image-editor" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Stock #: {{ stockNumber }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="onCloseModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <form @submit.prevent="setBoxData">
            <div class="modal-body">
              <div class="row">
                <div class="col-lg-8 col-md-12 form-group">
                  <div class="edit-image">
                    <vue-cropper
                      ref="cropper"
                      :src="getImageSource(image)"
                      alt="Source Image"
                      :guides="true"
                      :minCropBoxWidth="340"
                      :minCropBoxHeight="255"
                      :viewMode="0"
                      preview=".preview"
                    ></vue-cropper>
                  </div>

                  <div
                    class="edit-image-tool d-flex align-items-center justify-content-center my-3"
                  >
                    <div class="btn-group" role="group">
                      <a
                        type="button"
                        class="font-weight-bold text-uppercase text-dark pr-3"
                        @click.prevent="rotate(90)"
                        title="Rotate"
                        >Rotate/Flip <i class="fas fa-sync-alt"></i
                      ></a>
                    </div>
                    <div class="btn-group" role="group">
                      <a
                        type="button"
                        class="font-weight-bold text-uppercase text-dark pr-3"
                        @click.prevent="cropImage()"
                        title="Crop"
                        >Crop <i class="fas fa-crop"></i
                      ></a>

                      <a
                        type="button"
                        class="font-weight-bold text-uppercase text-dark"
                        @click.prevent="reset()"
                        title="Reset"
                        >Reset <i class="fas fa-undo"></i
                      ></a>
                    </div>
                  </div>
                </div>
                <div class="d-none d-lg-block d-md-none col-lg-4 col-md-12">
                  <section class="preview-area">
                    <p>Edited Image</p>
                    <div class="cropped-image">
                      <img v-if="cropImg" :src="cropImg" alt="Edited Image" />
                      <div v-else class="crop-placeholder" />
                    </div>
                  </section>
                  <div class="form-group">
                    <label for="name">Stock #:</label>
                    <input
                      type="text"
                      class="form-control"
                      :placeholder="stockNumber"
                      :disabled="stockNumber"
                    />
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="onCloseModal"
                >
                  Close
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  data-dismiss="modal"
                  @click="getData"
                >
                  Save
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueCropper from "vue-cropperjs";
import UploaderMixins from "../mixins/UploaderMixins.js";

export default {
  name: "PhotoEditor",
  mixins: [UploaderMixins],
  components: { VueCropper },
  props: {
    image: {
      type: Object,
    },
    openModal: {
      type: Boolean,
    },
  },
  data() {
    return {
      cropImg: "",
      data: null,
    };
  },
  computed: {
    stockNumber() {
      return this.$parent.selectedMachine
        ? this.$parent.selectedMachine.StockNumber
        : this.image.StockNumber;
    },
  },
  methods: {
    cropImage() {
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
    },
    rotate(deg) {
      this.$refs.cropper.rotate(deg);
    },
    reset() {
      this.$refs.cropper.reset();
    },
    getData() {
      this.data = JSON.stringify(this.$refs.cropper.getData(), null, 1);
      this.cropImage();
      this.$emit("updateImagePreview", this.cropImg);
      this.updateImage();
      this.onCloseModal();
    },
    updateImage() {
      this.updateImageData(this.image, this.cropImg);
    },
    setBoxData() {
      if (!this.data) return;
      this.$refs.cropper.setData(JSON.parse(this.data));
    },
    onCloseModal() {
      this.$emit("modal", false);
    },
  },
  watch: {
    image: {
      handler: function () {
        return this.$parent.selectedMachine &&
          this.$parent.selectedMachine.StockNumber
          ? this.$parent.selectedMachine.StockNumber
          : this.image.StockNumber;
      },
    },
  },
};
</script>